// 全局配置文件
const config = {
  // API接口地址
  apiBaseUrl: 'https://shipin.hrexample.asia/public/index.php/api',
  // apiBaseUrl: 'http://localhost:81/index.php/api',
  // 静态资源地址（图片、视频等）
  staticUrl: 'https://shipin.hrexample.asia/public'
  // staticUrl: 'http://localhost:81'
}

export default config
